import { z } from 'zod'

export const MEMBERSHIP_SCIM_BACKFILL_CONTRACT_VERSION = '1.0.0' as const

export const membershipScimBackfillResponseSchema = z.record(z.unknown())

export type MembershipScimBackfillResponse = z.infer<typeof membershipScimBackfillResponseSchema>
